import script from "./PiracyDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./PiracyDetail.vue?vue&type=script&lang=ts&setup=true"

import "./PiracyDetail.vue?vue&type=style&index=0&id=1a292dc0&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a292dc0"]])

export default __exports__